import { useCallback, useId } from 'react';

type IdGenerator = (segment?: string) => string;

/**
 * Returns a bound function that when invoked returns a unique string based on
 * a required namespace and segment name. Every invocation of the bound function
 * returns a consistent base ID combined with the namespace and segment.
 *
 * @example
 * const uid = useUniqueId('MyComponent')
 * uid('segment') => 'MyComponent-segment-r0'
 * uid('segment-two') => 'MyComponent-segment-two-r0'
 */
function useUniqueId(namespace: string) {
  const id = useId().replace(/:/g, '');

  return useCallback<IdGenerator>(
    segment => {
      const ret = [id];
      if (segment) ret.unshift(segment);
      ret.unshift(namespace);
      return ret.join('-');
    },
    [id, namespace],
  );
}

export default useUniqueId;
